import { useEffect } from "preact/hooks";
import { Outlet } from "react-router";
import { ClearPage } from "@/util/analyticsHelper.js";

export function AnalyticsTracking() {
  useEffect(() => {
    return () => {
      ClearPage();
    };
  });

  return <Outlet />;
}
